import { HttpClient } from '@angular/common/http';
import { SCAMP_API } from 'src/environments/environment';
import { TipoMaterial } from '../pages/domain/domain.model';
import { AccountService } from './account.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class TipoMaterialService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/tipos-materiais`, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/tipos-materiais/${id}`, { headers: this.account.composeHeaders() });
    }
    post(tipoMaterial) {
        return this.http.post(`${SCAMP_API.accountApiV1}/tipos-materiais`, tipoMaterial, { headers: this.account.composeHeaders() });
    }
    remove(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/tipos-materiais/${id}`, { headers: this.account.composeHeaders() });
    }
    alreadyRegistered(id, descricao) {
        return this.http.get(`${SCAMP_API.accountApiV1}/tipos_materiais/descricao-ja-cadastrada/${id}/${descricao}`, { headers: this.account.composeHeaders() });
    }
}
TipoMaterialService.ngInjectableDef = i0.defineInjectable({ factory: function TipoMaterialService_Factory() { return new TipoMaterialService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: TipoMaterialService, providedIn: "root" });
